import { Injectable } from '@angular/core';
import { environment} from '../../environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map} from 'rxjs/operators';
import { Router } from '@angular/router';
import { IDBPage } from '../model/db-page';
import { rolesStatus} from '../model/roles';
import { MessageService } from './message.service';


@Injectable({
  providedIn: 'root'
})
export class PageService {

  // private token;
  constructor(private http: HttpClient, private router: Router, private msgSer: MessageService) {
  }

  //
  // use jwt to look up page and return page record
  //
  // getLoggedInPage() {
  //   return this.http.get(`${environment.apiUrl}page/page-by-jwt/`)
  //      .pipe(map(res => { return res; }))
  //      .subscribe((data: any) => {
  //         if (data.status) {

  //         }
  //      }
  //   );
  // }

  getPages( center ): Observable<IDBPage> {
    return this.http.get(`${environment.apiUrl}page/all-pages/` + '?center=' + center )
       .pipe(map((res: any) => {
         return res.data;
       }));

  }

  //
  // Get Pages
  //
  getAllPages( center, page, per_page, sorting, filtering): Observable<any> {
    let add_url = '';
    if (filtering.name !== '') {
      add_url = add_url + '&name=' + filtering.companyname;
    }

    return this.http.get(`${environment.apiUrl}page/pages/` + '?center=' + center
                    + '&page=' + page
                    + '&per_page=' + per_page + '&sort_by=' + sorting.value + '&sort_type='
                    + sorting.sort + add_url )
       .pipe(map(res => { return res; }));
  }

  //
  // Creates a new Page record
  //
  createPage( form ) {

    return this.http.post(`${environment.apiUrl}page/`, form)
      .pipe(
        map((res: any) => {
          if (res.status) {
            return res;
          }
        })
      );
  }

  //
  // Update a page record
  //
  savePage( page_id, form ) {
    return this.http.post(`${environment.apiUrl}page/` + page_id, form
    )
    .pipe(
      map((res: any) => {
        if (res.status) {
          return res.status;
        }
      })
    );
  }

  //
  // Retrieve Page with given page-id
  //
  getPage( page_id ): Observable <IDBPage> {
    return this.http.get(`${environment.apiUrl}page/` + page_id)
        .pipe(
           map((res: any) => {
             if (res.status) {
               return res.data;
             }
           })
        );
  }


  //
  // Delete a new page record
  //
  deletePage( id ): Observable <any> {

    return this.http.delete(`${environment.apiUrl}page/` + id)
      .pipe(
        map((res: any) => {
          if (res.status) {
            return res;
          }
        })
      );
  }

}
